import { render, staticRenderFns } from "./FaceDirectionResultEffectFaceUp1.vue?vue&type=template&id=2b91e3b3&"
import script from "./FaceDirectionResultEffectFaceUp1.vue?vue&type=script&lang=ts&"
export * from "./FaceDirectionResultEffectFaceUp1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports